/* eslint-disable @typescript-eslint/no-explicit-any */
export class SPMakeOSCompanyExport {
  name: string;
  acronym: string;
  constructor(data: any) {
    this.name = data.name;
    this.acronym = data.acronym;
  }
}
